var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 0C20.816 0 0 20.816 0 46.5S20.816 93 46.5 93 93 72.184 93 46.5 72.184 0 46.5 0zm0 84.281c-20.834 0-37.781-16.949-37.781-37.781 0-20.832 16.947-37.781 37.781-37.781S84.281 25.668 84.281 46.5c0 20.832-16.947 37.781-37.781 37.781zm0-29.062a4.36 4.36 0 0 0 4.36-4.36V27.61a4.36 4.36 0 0 0-8.72 0v23.25a4.36 4.36 0 0 0 4.36 4.36zm0 6.012a5.712 5.712 0 0 0-5.71 5.71c.006 3.154 2.55 5.715 5.71 5.715s5.71-2.557 5.71-5.71c-.006-3.154-2.55-5.715-5.71-5.715z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdError);
export default __webpack_public_path__ + "static/media/id-error.b708821f.svg";
export { ForwardRef as ReactComponent };